import './style.css'

import {createPopup} from './popup';
import buttonFactory from './button';
import buttonController from './controller';
import {createReader} from './reader';
import state from './state';

document.addEventListener('DOMContentLoaded', function (e) {

  const btn = buttonFactory({window});
  const popup = createPopup({screen, window});
  const reader = createReader({window, pocketUrl: state.pocketUrl});

  buttonController({btn, popup, url: state.url, reader}).attach();
});
